import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { AuthService } from './core/services/auth.service';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'forgot',
    loadComponent: () =>
      import('./features/forgot-password/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent,
      ),
  },
  {
    // Bridge de login social para a extensão Chrome — ver extensao-chrome/README.md ("Login social").
    path: 'extension-auth',
    loadComponent: () =>
      import('./features/extension-auth/extension-auth.component').then(
        (m) => m.ExtensionAuthComponent,
      ),
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-layout/admin-layout.component').then(
            (m) => m.AdminLayoutComponent,
          ),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./features/admin/admin-dashboard/admin-dashboard.component').then(
                (m) => m.AdminDashboardComponent,
              ),
          },
          {
            path: 'administrators',
            loadComponent: () =>
              import('./features/admin/administrators-page/administrators-page.component').then(
                (m) => m.AdministratorsPageComponent,
              ),
          },
          {
            path: 'partner-stores',
            loadComponent: () =>
              import('./features/admin/partner-stores-page/partner-stores-page.component').then(
                (m) => m.PartnerStoresPageComponent,
              ),
          },
          {
            path: 'users/:externalId',
            loadComponent: () =>
              import(
                './features/admin/admin-user-wishlists-page/admin-user-wishlists-page.component'
              ).then((m) => m.AdminUserWishlistsPageComponent),
          },
          {
            path: 'users',
            loadComponent: () =>
              import('./features/admin/users-admin-page/users-admin-page.component').then(
                (m) => m.UsersAdminPageComponent,
              ),
          },
          {
            path: 'reports',
            loadComponent: () =>
              import('./features/admin/admin-reports-page/admin-reports-page.component').then(
                (m) => m.AdminReportsPageComponent,
              ),
          },
        ],
      },
      {
        path: 'user/:username/wishlists',
        loadComponent: () =>
          import('./features/user-wishlists/user-wishlists.component').then(
            (m) => m.UserWishlistsComponent
          ),
      },
      {
        path: 'wishlists/:externalId',
        loadComponent: () =>
          import('./features/wishlists/wishlist-detail/wishlist-detail.component').then(
            (m) => m.WishlistDetailComponent
          ),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./features/settings/privacy-policy/privacy-policy.component').then(
            (m) => m.PrivacyPolicyComponent,
          ),
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./features/legal/terms-of-service-page/terms-of-service-page.component').then(
            (m) => m.TermsOfServicePageComponent,
          ),
      },
      {
        path: 'explore',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/explore/explore.component').then((m) => m.ExploreComponent),
      },
      {
        path: 'wishlists',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/wishlists/wishlists.component').then(
            (m) => m.WishlistsComponent
          ),
      },
      {
        path: 'friends',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/friends/friends.component').then((m) => m.FriendsComponent),
      },
      {
        path: 'friends/connections',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/friends/friends-connections-mobile.component').then(
            (m) => m.FriendsConnectionsMobileComponent,
          ),
      },
      {
        path: 'reservations',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/reservations/reservations.component').then((m) => m.ReservationsComponent),
      },
      {
        path: 'profile/edit',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/profile/profile-edit/profile-edit.component').then(
            (m) => m.ProfileEditComponent
          ),
      },
      {
        path: 'settings',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/settings/settings-layout/settings-layout.component').then(
            (m) => m.SettingsLayoutComponent
          ),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./features/settings/settings.component').then(
                (m) => m.SettingsComponent
              ),
          },
          {
            path: 'notifications',
            loadComponent: () =>
              import(
                './features/settings/notifications-settings/notifications-settings.component'
              ).then((m) => m.NotificationsSettingsComponent),
          },
          {
            path: 'password',
            loadComponent: () =>
              import('./features/settings/password-privacy-settings/password-privacy-settings.component').then(
                (m) => m.PasswordPrivacySettingsComponent,
              ),
          },
          {
            path: 'faq',
            loadComponent: () =>
              import('./features/settings/faq-settings-page/faq-settings-page.component').then(
                (m) => m.FaqSettingsPageComponent,
              ),
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: () => inject(AuthService).isAuthenticated() ? '/wishlists' : '/',
  },
];
